import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'displayHectare'
})
export class DisplayHectarePipe implements PipeTransform {
    transform(number: number): number {
        return Math.round(number / 10000)
    }

}